import { FlatNode } from '../pages/mindmap/types';

/**
 * Determines which node is the nearest on the X-axis to a given X-coordinate.
 * @param children List of nodes.
 * @param cursorX Given X-coordinate to which the nearest node should be determined.
 * @returns The node which is nearest to the given X-coordinate and an indication if the given
 *          X-coordinate is on the left or right side of the node.
 */
export const determineNearestChildNode = ({
  children,
  cursorX,
}: {
  children: FlatNode[];
  cursorX: number;
}): { closestChild: FlatNode | undefined; side: 'left' | 'right' } => {
  let closestChild: FlatNode | undefined = undefined;
  let side: 'left' | 'right' = 'left';

  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    const childX = child.x;

    if (childX) {
      if (cursorX < childX) {
        closestChild = child;
        side = 'left';
        break;
      }

      const childRightX = childX + child.width;

      if (cursorX > childX && cursorX < childRightX) {
        // inside of child width
        closestChild = child;
        if (cursorX < childX + child.width / 2) {
          // left side of child
          side = 'left';
        } else {
          // right side of child
          side = 'right';
        }
        break;
      }

      const nextChild = children[i + 1];

      if (nextChild) {
        const nextChildX = nextChild.x;

        if (nextChildX) {
          if (cursorX < childRightX + (nextChildX - childRightX) / 2) {
            // right side of child
            closestChild = child;
            side = 'right';
            break;
          }
          if (cursorX < childRightX + (nextChildX - childRightX)) {
            // left side of nextchild
            closestChild = nextChild;
            side = 'left';
            break;
          }
        }
      } else {
        // right side of child
        closestChild = child;
        side = 'right';
        break;
      }
    }
  }

  return { closestChild, side };
};
